module.exports = __webpack_public_path__ + "img/tik-tok.088d66bb.svg";